import React, { useState, useEffect } from 'react';
import SpotsSearchPanel from './SpotsSearchPanel';
import { GetCampaignBurstTransmitters, GetCampaignTransmitters } from '../../../services/CampaignsDataService';
import { pageContainerStyle, sectionedPanelStyle } from '../CampaignStyles';

const apiParamDefaults = {
    pageNumber: 1,
    pageSize: 1000
};

const TransmissionTimes = ({ campaign, campaignBurst, campaignVersionId, campaignStartDate, campaignEndDate, currentCampaignName }) => {
    const [transmitters, setTransmitters] = useState([]);

    useEffect(() => {
        const params = { ...apiParamDefaults, campaignVersionId: campaignVersionId }
        if (campaignBurst) {
            GetCampaignBurstTransmitters(campaignBurst?.id, params)
                .then((data) => {
                    setTransmitters(data?.data);
                })
                // eslint-disable-next-line no-console
                .catch(console.log);
        } else {

            GetCampaignTransmitters(campaign?.id, params)
                .then((data) => {
                    setTransmitters(data?.data);
                })
                // eslint-disable-next-line no-console
                .catch(console.log);
        }
    }, [campaign, campaignBurst]);

    return (
        <div style={pageContainerStyle}>
            <div style={sectionedPanelStyle}>
                <SpotsSearchPanel
                    campaignId={campaign?.id}
                    campaignBurstId={campaignBurst?.id}
                    transmitterList={transmitters}
                    campaignStartDate={campaignStartDate}
                    campaignEndDate={campaignEndDate}
                    currentCampaignName={currentCampaignName}
                    campaignVersionId={campaignVersionId}
                />
            </div>
        </div>
    );
};

export default TransmissionTimes;
